export default __webpack_public_path__ + "static/media/cblogo.a2188627.jpg";